import catalog from './catalog'
import content from './content'
import ad from './ad'
import params from './params'
import mock from './mock'

export default {
  catalog,
  content,
  ad,
  params,
  mock
}



// WEBPACK FOOTER //
// ./src/api/cms/index.js